export default "__VITE_ASSET__fd5cb990__"